import { computed, type SetupContext } from 'vue';
import { SubmitType } from '@/domain/enums/submit-type';
import Actions from '@/dictionary/tracking/actions';
import Labels from '@/dictionary/tracking/labels';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { trackIncentiveAction } from '@/utils/tracking/incentive-tracking';

export default class Submit {
	public type: SubmitType;
	public context: SetupContext;

	public pending = computed((): boolean => {
		return this.store.getters.pending();
	});

	public submitType = computed((): typeof SubmitType => {
		return SubmitType;
	});

	public buttonText = {
		[SubmitType.LOG_IN]: 'Log in',
		[SubmitType.REGISTER]: 'Register for free',
		[SubmitType.CONFIRM]: 'Confirm',
		[SubmitType.RESET_PASSWORD]: 'Send reset link',
	};
	constructor(public store: IIncentiveV2Store, type: SubmitType, context: SetupContext) {
		this.type = type;
		this.context = context;
	}

	public submitButtonClicked(event: Event): void {
		event.preventDefault();
		this.context.emit('submitButtonClicked');
		this.trackSubmitButtonClick();
	}

	public trackSubmitButtonClick(): void {
		const action = this.pending.value ? Labels.CLICKED_WHEN_PENDING : Actions.SUBMIT_CLICK + ' - ' + this.type;
		trackIncentiveAction(
			action,
			this.store.getters.incentiveType(),
			this.store.getters.location(),
			this.store.getters.uniqueIdentifier(),
		);
	}
}
